import { defineComponent as _defineComponent } from 'vue'
import { generalApi } from '@/lib/api/general';
import { defineMessages } from '@/lib/i18n';
import { onMounted, ref } from 'vue';
import store from '@/store';
import { dispatchGetCurrentUser } from '@/store/main/actionsMain';
import router from '@/router';
import { regulationDatabaseUrl } from '@/env';
import { resolveSamlCompleteHref } from '@/utils/redirectWhitelist';


export default /*#__PURE__*/_defineComponent({
  __name: 'SamlLoginCompletePage',
  setup(__props) {

const LIMIT_RETRY_COUNT = 10;

const retryCount = ref(0);

const sleep = (time: number) =>
  new Promise((resolve) => setTimeout(resolve, time));

const m = defineMessages({
  description:
    'SAMLログインが完了しました。ケミカンへのログインを試みています。',
});

const checkUserStatus = async () => {
  if (retryCount.value === LIMIT_RETRY_COUNT) {
    return false;
  }

  // Wait 3 seconds before each attempt to allow webhook processing to complete
  await sleep(3000);
  retryCount.value++;

  try {
    const response = await generalApi.getMe();

    if (response.data) {
      return true;
    }
  } catch (e: unknown) {
    // Continue retrying - 404 errors can occur temporarily after user restoration
    // Only fail after exhausting all retry attempts
  }

  return await checkUserStatus();
};

onMounted(async () => {
  const isUserActivated = await checkUserStatus();

  if (isUserActivated) {
    // Update store with current user information before redirecting
    // This ensures the auth guards recognize the user as logged in
    await dispatchGetCurrentUser(store);

    // Return to where the user started (e.g. the regulation app) when
    // /saml/login passed an allowed `redirect`; otherwise the SDS list.
    window.location.href =
      resolveSamlCompleteHref(
        router.currentRoute.query.redirect,
        window.location.origin,
        regulationDatabaseUrl
      ) ?? '/#/dashboard/sds/index';
  }
});

return { __sfc: true,LIMIT_RETRY_COUNT, retryCount, sleep, m, checkUserStatus }
}

})